export const style = (theme) => ({
  labelChart: {
    textAlign: "center",
    fontSize: "0.89rem",
    lineHeight: "normal",
    textTransform: "capitalize",
  },
  countReact: {
    backgroundColor: "rgba(201, 203, 209, 0.25)",
    width: "100%",
    minWidth: 50,
    minHeight: "3rem",
    fontWeight: "bold",
    fontSize: "1.78rem",
    [theme.breakpoints.up("md")]: {
      minHeight: "3.56rem",
    },
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    marginBottom: theme.spacing(2),
    marginTop: theme.spacing(2),
  },
  row_info: {
    display: "flex",
    marginTop: theme.spacing(1),
    marginBottom: theme.spacing(1),
    textTransform: "capitalize",
  },
  infoTitle: {
    overflow: "hidden",
    textOverflow: "ellipsis",
    fontSize: "0.89rem",
  },
  container: {
    paddingTop: theme.spacing(6),
    paddingBottom: theme.spacing(3),
    paddingLeft: theme.spacing(3),
    paddingRight: theme.spacing(3),
    [theme.breakpoints.down("md")]: {
      padding: `${theme.spacing(2)}px ${theme.spacing(3)}px`,
    },
  },
  colStatus: {
    display: "flex",
    flexDirection: "column",
    height: "100%",
    justifyContent: "center",
  },
  square: {
    marginRight: "1rem",
    width: "1.2rem",
    height: "1.2rem",
    minWidth: 24,
    minHeight: 24,
  },
  square_gold: {
    backgroundColor: "#eebe00",
  },
  square_silver: {
    backgroundColor: "#9497a3",
  },
  square_bronze: {
    backgroundColor: "#f37f00",
  },
  square_basic: {
    backgroundColor: "#1ea000",
  },
  square_custom: {
    backgroundColor: "#3F98FF",
  },
});
